<!-- <p>orders-auth works!</p>
<ng-container *transloco="let t; prefix: 'tasks'">
  <h2>Lingua corrente: {{t('lang')}}</h2>
</ng-container> -->

<button matButton="filled" (click)="goToList()">Go to List</button>